import {
  ItemReceiptLine,
  type ItemReceiptLineConstructor,
} from '../ItemReceiptLine'

export interface QuickBooksExportableItemReceiptConstructor {
  id: number // selection key for stage/archive/unstage
  purchaseOrderLabel: string // "PO" column, e.g. "PO-1023"
  poUuid: string // detail link /receive/{po_uuid}
  date: Date // "Date received" column + View Items modal date
  receiverName: string
  items: ItemReceiptLineConstructor[]
  stagedForExport: boolean // mapper defaults to false when absent (v3 row shape not live-observed on this tenant)
}

export class QuickBooksExportableItemReceipt {
  readonly id: number
  readonly purchaseOrderLabel: string
  readonly poUuid: string
  readonly date: Date
  readonly receiverName: string
  readonly items: ItemReceiptLine[]
  readonly stagedForExport: boolean

  constructor(data: QuickBooksExportableItemReceiptConstructor) {
    this.id = data.id
    this.purchaseOrderLabel = data.purchaseOrderLabel
    this.poUuid = data.poUuid
    this.date = data.date
    this.receiverName = data.receiverName
    this.items = data.items.map((item) => new ItemReceiptLine(item))
    this.stagedForExport = data.stagedForExport
  }

  // "Number of lines" column (BHV-044).
  get lineCount(): number {
    return this.items.length
  }
}
